/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Button } from '@atoms';
import { TextField, SelectField } from '@molecules';
import { ADD_LINK_FIELD } from './constant';
import Form from '../Form';

import s from './styles.module.less';

const AddLink = ({ onAdd }) => {
  const [form] = Form.useForm();

  const handleFinish = (values) => {
    const { [ADD_LINK_FIELD.SITE.name]: site, [ADD_LINK_FIELD.USERNAME.name]: username } = values;
    onAdd(`${site}${username}`);

    form.resetFields();
  };

  return (
    <Form form={form} onFinish={handleFinish} wrapperCol={{ span: 12 }} className={s.addLinkForm}>
      <SelectField {...ADD_LINK_FIELD.SITE} />
      <TextField {...ADD_LINK_FIELD.USERNAME} />
      <Button type="customBlue" htmlType="submit">
        ADD LINK
      </Button>
    </Form>
  );
};

export default AddLink;
